import { GameStatues } from "@grassrootly/api";
import { ClassName, Div, Label } from "@grassrootly/rn-core";
import { useMemo } from "react";

export default function GameStatus({ status }: { status: GameStatues }) {
  const { color, statusText, border }: { color: ClassName; border: ClassName; statusText: GameStatues } =
    useMemo(() => {
      switch (status) {
        case GameStatues.FINALIZED:
        case GameStatues.FINISHED:
          return { color: "", statusText: GameStatues.FINISHED, border: "borderPrimary" };
        case GameStatues.CANCELED:
          return { color: "colorDangerMain", statusText: GameStatues.CANCELED, border: "borderDanger" };
        default:
          return { color: "", statusText: GameStatues.SCHEDULED, border: "borderPrimary" };
      }
    }, [status]);

  return (
    <Div classNames={["br-{8}", "pv-{8}", "ph-{12}", "bw-{1}", "mt-{16}", border]}>
      <Label type="l2Regular" classNames={[color]}>
        {statusText}
      </Label>
    </Div>
  );
}
